export const hero = {
  badge: "موثوق في السعودية • تغطية الجنوب كاملة",
  title: "برنامج كاشير ومحاسبة متكامل + أجهزة كاشير — كل ما يحتاجه نشاطك",
  subtitle:
    "خبرة 4 سنوات وأكثر من 800 عميل نشط. نخدم خميس مشيط، أبها، جيزان، نجران، الباحة وباقي مدن المنطقة الجنوبية.",
  stats: [
    { label: "عميل نشط", value: "+800" },
    { label: "سنوات", value: "4" },
    { label: "تغطية الجنوب", value: "5 مدن+" },
  ],
};
